import EditNote from '@mui/icons-material/EditNote';
import type { SvgIconComponent } from '@mui/icons-material';

const NOTE = 'Note';

export const VENDOR_TIMELINE_RECORD_TYPES = {
  [NOTE]: NOTE,
} as const;

export type VendorTimelineType = (typeof VENDOR_TIMELINE_RECORD_TYPES)[keyof typeof VENDOR_TIMELINE_RECORD_TYPES];

export const VENDOR_TIMELINE_MESSAGE_CONTEXT = 'CVENDOR_TIMELINE_MESSAGE_CONTEXT';

export const VENDOR_TIMELINE_ICONS: Record<VendorTimelineType, SvgIconComponent> = {
  [NOTE]: EditNote,
} as const;
